import { useMutation } from 'react-query'
import { showConfirmAlert, showError } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteLoteExamesCliente } from '../../core/_request'
import { TableBulkDangerButton, TableSelectionBar, useToast } from '../../../../../../components'

export const ExameClienteListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const { refetch } = useQueryResponse()
  const { showToast } = useToast()
  const count = selected.length

  const deleteSelected = useMutation(() => deleteLoteExamesCliente(selected), {
    onSuccess: () => {
      showToast({
        variant: 'success',
        title: count === 1 ? '1 exame removido.' : `${count} exames removidos.`,
      })
      clearSelected()
      refetch()
    },
    onError: (error) => {
      showError(error)
      refetch()
    },
  })

  const askRemove = async () => {
    const confirmed = await showConfirmAlert({
      title: count === 1 ? 'Remover 1 exame?' : `Remover ${count} exames?`,
      text: 'Os exames selecionados serão excluídos. Essa ação não pode ser desfeita.',
      confirmButtonText: count === 1 ? 'Remover exame' : `Remover ${count} exames`,
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await deleteSelected.mutateAsync()
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <TableBulkDangerButton onClick={askRemove} disabled={deleteSelected.isLoading}>
        {count === 1 ? 'Remover selecionado' : 'Remover selecionados'}
      </TableBulkDangerButton>
    </TableSelectionBar>
  )
}
